import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import KanbanBoard from "../../../components/Kanban/KanbanBoard";
import { fetchPipeline } from "../../../redux-store/slices/pipelineSlice";

const ActiveStages = ({tab,onSelectCandidate}) => {
  
  const { currentType, pipelineByType } = useSelector(
    (state) => state.pipeline
  );
// const dispatch = useDispatch();
// useEffect(() => {
//   const today = new Date().toISOString().split("T")[0];

//   // 1️⃣ Load all stages
//   dispatch(fetchPipeline({ stage_id: null }));

//   // 2️⃣ Override Stage 8
//   dispatch(
//     fetchPipeline({
//       stage_id: 8,
//       date_from: "2025-12-01",
//       date_to: today,
//     })
//   );
// }, [dispatch]);
  
  // console.log(pipelineByType,"pipeline by type",currentType);
  const kanbanData =
    pipelineByType[currentType]?.kanbanData || [];

 const leadData = kanbanData.filter(
    (stage) => stage.type === "LEAD"
  );

  const interviewData = kanbanData.filter(
    (stage) => stage.type === "INTERVIEW"
  );
  return <KanbanBoard stages={interviewData} menu={true} activeTab={tab} onSelectCandidate={onSelectCandidate} />;
};

export default ActiveStages;
